export const CALC_TYPE_LESS_IS_BETTER = 'less_is_better';
export const CALC_TYPE_ZERO_TARGET = 'zero_target';
export const CALC_TYPE_NORMAL = 'normal';
export const CALC_TYPE_EARLY_COMPLETION = 'early_completion';
